import React, { useState } from "react";

const Hotspot = ({ cards, setIsFullscreen, baseURL }) => {
  const [activeHotspot, setActiveHotspot] = useState(null);

  return (
    <div
      className="fixed top-[56.6px] left-0 w-screen h-[calc(100vh-56.6px)] bg-gray-900 bg-opacity-90 flex flex-col items-center p-[20px] overflow-y-auto"
      onClick={() => setIsFullscreen(false)}
      style={{ zIndex: 1000 }}
    >
      {/* Container for Header, Image, and Footer */}
      <div className="flex flex-col items-center w-[90%] h-full">
        {/* Header */}
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-[#373737] text-white text-center py-2 text-[16px] w-full"
        >
          For more information please click on UKL logo or product image
        </div>

        {/* Image & Hotspots */}
        <div
          className="relative flex flex-col justify-center items-center w-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative w-full">
            {/* Close Button */}
            <button
              className="absolute top-2 right-2 bg-[#868788] text-2xl font-bold text-white p-[8.5px] py-2 rounded-full hover:bg-[#afb0b0] transition"
              onClick={() => setIsFullscreen(false)}
            >
              ✕
            </button>

            {/* Zoomed Image */}
            <img
              src={baseURL.concat(
                cards?.[0]?.attributes?.IndustryBanner?.data?.attributes?.url ||
                  ""
              )}
              alt="Industry Banner"
              className="w-full h-auto object-contain"
            />

            {/* Hotspots */}
            {cards?.[0]?.attributes?.hotspots?.map((spot, index) => (
              <div
                key={index}
                className="hotspot-hover-point absolute"
                style={{
                  top: `${spot.top}`,
                  left: `${spot.left}`,
                  transform: "translate(-50%, -50%)"
                }}
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  setActiveHotspot(activeHotspot === index ? null : index);
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                  setActiveHotspot(activeHotspot === index ? null : index);
                }}
              >
                {/* Hotspot Marker */}
                <div className="ripple-1"></div>
                <div className="ripple-2"></div>
                <div className="ripple-3"></div>

                {/* Hotspot Info */}
                <div
                  className="hotspot-hover-card absolute bg-gray-700 text-white p-2 rounded"
                  style={{
                    margin: "25px 0px",
                    top: "0px",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  <h4>{spot.text}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer - Ensured visibility */}
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-[#373737] text-white text-center py-2 text-[16px] w-full flex-grow-0"
        >
          Uni Klinger products play a silent and important role to help in
          manufacturing of medicine which keeps you fit and healthy
        </div>
      </div>
    </div>
  );
};

export default Hotspot;
